const path = 'sales';

export default [
  {
    path: path,
    name: 'sales',
    component: () => import('@views/sales/Index'),
  },
];